import request from '@/utils/request'

// 查询企业设备列表
export function listDevice(query) {
  return request({
    url: '/kl/device/list',
    method: 'get',
    params: query
  })
}
// 分页查询企业设备列表
export function paginationDevice(query = {}, pagination) {
  return request({
    url: `/kl/device/pagination?pageNum=${pagination.pageNum}&pageSize=${pagination.pageSize}`,
    method: 'post',
    data: query
  })
}

// 查询所有企业设备列表
export function listAllDevice(data) {
  return request({
    url: '/kl/device/listAll',
    method: 'post',
    data: data
  })
}
// 查询企业设备状态
export function deviceStatusCount(data) {
  return request({
    url: '/kl/device/deviceStatusCount',
    method: 'post',
    data: data
  })
}

// 查询实体下设备列表
export function entityDeviceList(query) {
  return request({
    url: '/kl/device/entityDeviceList',
    method: 'get',
    params: query
  })
}

// 查询企业设备详细
export function getDevice(id) {
  return request({
    url: '/kl/device/' + id,
    method: 'get'
  })
}

// 新增企业设备
export function addDevice(data) {
  return request({
    url: '/kl/device',
    method: 'post',
    data: data
  })
}

// 修改企业设备
export function updateDevice(data) {
  return request({
    url: '/kl/device',
    method: 'put',
    data: data
  })
}

// 设备绑定出入口信息
export function deviceBindPassageway(data) {
  return request({
    url: '/kl/device/bindPassageway',
    method: 'post',
    data: data
  })
}

// 解除设备绑定出入口信息
export function unDeviceBindPassageway(data) {
  return request({
    url: '/kl/device/unDeviceBindPassageway',
    method: 'post',
    data: data
  })
}

// 删除企业设备
export function delDevice(id) {
  return request({
    url: '/kl/device/' + id,
    method: 'delete'
  })
}
